import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataService } from 'src/app/shared/data.service';
import { UtilsService } from 'src/app/shared/utils.service';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';
import { User } from 'src/app/auth/user.model';
import { AuthService } from 'src/app/auth/auth.service';

@Component({
    selector: 'app-add-edit-material',
    templateUrl: './add-edit-material.component.html',
    styleUrls: ['./add-edit-material.component.scss'],
    standalone: false
})
export class AddEditMaterialComponent implements OnInit {
  invalidFiles: boolean;
  fileIconOn: boolean;
  filesList: FileList = null;
  addMaterialForm: FormGroup;
  type: string;
  id: number;
  material: any;
  page: any;
  productId: any;
  user: User;

  constructor(public dialogRef: MatDialogRef<AddEditMaterialComponent>,
              private dataService: DataService,
              public utils: UtilsService,
              private authService: AuthService,
              private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any)  {
                this.type = data.type;
                this.id = data.id;
                this.user = this.authService.getUserData();
                this.page = data.page;
                this.productId = data.productId;
                this.fileIconOn = true;
                if (this.type === 'Edit') {
                  this.getMaterial();
                }
   }

  ngOnInit(): void {
    this.addMaterialForm = new FormGroup({
      description: new FormControl(this.material ?  this.material.description : null, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
      name: new FormControl(this.material ?  this.material.expirationDate : null, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
      link: new FormControl(this.material ?  this.material.path : null, [Validators.required, Validators.pattern(this.utils.urlReg)]),
      file: new FormControl({ value: this.material ?  this.material.fileName : null, disabled: true }),
    });
  }

  getMaterial() {
    if (this.page === 'company') {
      this.dataService.get('companySupportMaterial/RetrieveSupportMaterialById/' + this.id).then((data) => {
        if (data.statusCode === 200) {
          this.material = data.data;
          this.addMaterialForm.controls.description.setValue(this.material.description);
          this.addMaterialForm.controls.name.setValue(this.material.name);
          if (this.material.type === 2) {
            this.fileIconOn = false;
            this.addMaterialForm.controls.link.setValue(this.material.path);
          } else if (this.material.type === this.utils.supportMaterials.Document || this.material.type === this.utils.supportMaterials.Image) {
            this.addMaterialForm.get('file').setValue(this.material.fileName);
          }
        }
      });
    } else {
      let retrieveApi = '';
      if (this.page === 'training') {
        retrieveApi = 'trainingMaterial/RetrieveTrainingMaterialById/';
      } else {
        retrieveApi = 'marketingMaterial/RetrieveMarketingMaterialById/';
      }
      this.dataService.get('product/' + retrieveApi +
      this.productId + '/' + this.id).then((data) => {
        if (data.statusCode === 200) {
          this.material = data.data;
          this.addMaterialForm.controls.description.setValue(this.material.description);
          this.addMaterialForm.controls.name.setValue(this.material.name);
          if (this.material.type === 2) {
            this.fileIconOn = false;
            this.addMaterialForm.controls.link.setValue(this.material.path);
          } else if (this.material.type === this.utils.supportMaterials.Document || this.material.type ===  this.utils.supportMaterials.Image) {
            this.addMaterialForm.get('file').setValue(this.material.fileName);
          }
        }
      });
    }
  }

  toggleIcon(type: string) {
    if (type === 'link' && this.fileIconOn) {
      this.invalidFiles = false;
      this.addMaterialForm.get('link').setValue(null);
      this.fileIconOn = !this.fileIconOn;
    } else if (type === 'file' && !this.fileIconOn) {
      this.filesList = null;
      this.fileIconOn = !this.fileIconOn;
      this.addMaterialForm.get('file').setValue('');
    }
  }

  closeDialog() {
    if (this.addMaterialForm.dirty && this.type === 'Add') {
      const dialogRef = this.dialog.open(AlertDialogComponent, {
        disableClose: true,
        width: '400px',
        data: {
          title: 'Warning',
          type: 'Warn',
          message: 'You will miss your information once you close',
          buttonText: 'cancel',
          numberOfButtons: 2,
          seconButtonText: 'Ok'
        }
      });
      dialogRef.afterClosed().subscribe((status) => {
        if (status === 'Ok') {
          this.dialog.closeAll();
        }
      });
    } else {
      this.dialog.closeAll();
    }
  }

  previewImage(fileList: any) {
    this.filesList = fileList;
    if (fileList.length > 0) {
      this.invalidFiles = false;
    }
    let name = '';
    for (let index = 0; index < fileList.length; index++) {
      if (index === 0) {
        name = fileList[index].name;
      } else {
        name = name + ',' + fileList[index].name;
      }
    }
    this.addMaterialForm.get('file').setValue(name);
  }

  onSubmit() {
    if (this.filesList && this.filesList.length > 0) {
    } else {
      if (this.fileIconOn) {
        if (this.material && this.material.fileName) {
        } else {
          this.invalidFiles = true;
          this.addMaterialForm.markAllAsTouched();
          return;
        }
      }
    }
    if (this.fileIconOn) {
      this.addMaterialForm.get('link').setValue('https://link.link');
    }
    if (this.addMaterialForm.valid) {
      if (this.type === 'Edit') {
        let updateApi = '';
        let message = '';
        if (this.page === 'training') {
          updateApi = 'trainingMaterial/UpdateTrainingMaterial';
          message = 'Training material updated successfully';
        } else {
          updateApi = 'marketingMaterial/UpdateMarketingMaterial';
          message = 'Marketing material updated successfully';
        }
        const payload = {
          materialId: this.id,
          productId: parseInt(this.productId.toString(), 10),
          description: this.addMaterialForm.get('description').value,
          name: this.addMaterialForm.get('name').value,
        };
        this.utils.showProgressDialog();
        this.dataService.put('product/' + updateApi, payload, true).then((data) => {
          if (data.statusCode === 200) {
              if (this.fileIconOn) {
                if (this.filesList && this.filesList.length > 0) {
                  this.updateMaterial(payload);
                } else {
                  const dialogRef = this.dialog.open(AlertDialogComponent, {
                    disableClose: true,
                    width: '400px',
                    data: {
                      title: 'Success',
                      type: 'Success',
                      message,
                      buttonText: 'Ok'
                    }
                  });
                  this.dialogRef.close(payload);
                }
              } else {
                if (this.addMaterialForm.get('link').value === this.material.path) {
                  this.dialogRef.close(payload);
                  const dialogRef = this.dialog.open(AlertDialogComponent, {
                    disableClose: true,
                    width: '400px',
                    data: {
                      title: 'Success',
                      type: 'Success',
                      message,
                      buttonText: 'Ok'
                    }
                  });
                } else {
                  this.updateMaterial(payload);
                  this.dialogRef.close(payload);
                }
              }
          } else {
            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Error',
                type: 'Error',
                message: 'Something went wrong, Please try again!',
                buttonText: 'Ok'
              }
            });
          }
        });
        this.utils.closeProgressDialog();
      } else if (this.type === 'Add') {
        let createApi = '';
        let updateFileApi = '';
        let message = '';
        if (this.page === 'training') {
          createApi = 'trainingMaterial/CreateTrainingMaterial';
          updateFileApi = 'trainingMaterial/UpdateTrainingMaterialFile';
          message = 'Training material added successfully';
        } else {
          createApi = 'marketingMaterial/CreateMarketingMaterial';
          updateFileApi = 'marketingMaterial/UpdateMarketingMaterialFile';
          message = 'Marketing material added successfully';
        }
        const payload = {
          productId: parseInt(this.productId.toString(), 10),
          description: this.addMaterialForm.get('description').value,
          name: this.addMaterialForm.get('name').value,
        };
        this.utils.showProgressDialog();
        this.dataService.post('product/' + createApi, payload, true).then((data) => {
          if (data.statusCode === 200) {
            this.dialogRef.close(data.data);
            const imagePayload = new FormData();
            imagePayload.append('file', this.filesList && this.filesList.length > 0 && this.fileIconOn ? this.filesList[0] : null);
            imagePayload.append('link', this.filesList && this.filesList.length > 0 && this.fileIconOn  ? null : this.addMaterialForm.get('link').value);
            imagePayload.append('materialId', data.data.id);
            imagePayload.append('productId', this.productId.toString());
            imagePayload.append('type', this.filesList && this.filesList.length > 0 && this.fileIconOn ? '4' : '2');

            this.dataService.put('product/' + updateFileApi, imagePayload, true).then((mediaData) => {
              if (mediaData.statusCode === 200) {
                this.dialogRef.close(payload);
                const dialogRef = this.dialog.open(AlertDialogComponent, {
                  disableClose: true,
                  width: '400px',
                  data: {
                    title: 'Success',
                    type: 'Success',
                    message,
                    buttonText: 'Ok'
                  }
                });
              } else {
                const dialogRef = this.dialog.open(AlertDialogComponent, {
                  disableClose: true,
                  width: '400px',
                  data: {
                    title: 'Error',
                    type: 'Error',
                    message: 'Something went wrong, Please try again!',
                    buttonText: 'Ok'
                  }
                });
              }
            });
          } else {
            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Error',
                type: 'Error',
                message: 'Something went wrong, Please try again!',
                buttonText: 'Ok'
              }
            });
          }
        });
        this.utils.closeProgressDialog();
      }
    }
  }

  updateMaterial(payload: any) {
    let updateFileApi = '';
    let message = '';
    if (this.page === 'training') {
      updateFileApi = 'trainingMaterial/UpdateTrainingMaterialFile';
      message = 'Training material updated successfully';
    } else {
      updateFileApi = 'marketingMaterial/UpdateMarketingMaterialFile';
      message = 'Marketing material updated successfully';
    }
    const imagePayload = new FormData();
    imagePayload.append('file', this.filesList && this.filesList.length > 0 ? this.filesList[0] : null);
    imagePayload.append('link', this.filesList && this.filesList.length > 0 ? null : this.addMaterialForm.get('link').value);
    imagePayload.append('materialId', this.id.toString());
    imagePayload.append('productId', this.productId.toString());
    imagePayload.append('type', this.filesList && this.filesList.length > 0 ? '4' : '2');

    this.dataService.put('product/' + updateFileApi, imagePayload, true).then((mediaData) => {
      if (mediaData.statusCode === 200) {
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Success',
            type: 'Success',
            message,
            buttonText: 'Ok'
          }
        });
        this.dialogRef.close(payload);
      } else {
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Error',
            type: 'Error',
            message: 'Something went wrong, Please try again!',
            buttonText: 'Ok'
          }
        });
      }
    });
  }

  updateCompanyMaterial(payload: any) {
    const imagePayload = new FormData();
    imagePayload.append('file', this.filesList && this.filesList.length > 0 ? this.filesList[0] : null);
    imagePayload.append('link', this.filesList && this.filesList.length > 0 ? null : this.addMaterialForm.get('link').value);
    imagePayload.append('recordId', this.id.toString());
    imagePayload.append('type', this.filesList && this.filesList.length > 0 ? '4' : '2');

    this.dataService.put('companySupportMaterial/UpdateCompanySupportMaterialFile', imagePayload, true).then((mediaData) => {
      if (mediaData.statusCode === 200) {
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Success',
            type: 'Success',
            message: 'Material updated successfully',
            buttonText: 'Ok'
          }
        });
        this.dialogRef.close(payload);
      } else {
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Error',
            type: 'Error',
            message: 'Something went wrong, Please try again!',
            buttonText: 'Ok'
          }
        });
      }
    });
  }

  onCompanySubmit() {
    if (this.filesList && this.filesList.length > 0) {
    } else {
      if (this.fileIconOn) {
        if (this.material && this.material.fileName) {
        } else {
          this.invalidFiles = true;
          this.addMaterialForm.markAllAsTouched();
          return;
        }
      }
    }
    if (this.fileIconOn) {
      this.addMaterialForm.get('link').setValue('https://link.link');
    }
    if (this.addMaterialForm.valid) {
      if (this.type === 'Edit') {
        const payload = {
          id: this.id,
          description: this.addMaterialForm.get('description').value,
          name: this.addMaterialForm.get('name').value,
        };
        this.utils.showProgressDialog();
        this.dataService.put('companySupportMaterial/UpdateCompanySupportMaterial', payload, true).then((data) => {
          if (data.statusCode === 200) {
              if (this.fileIconOn) {
                if (this.filesList && this.filesList.length > 0) {
                  this.updateCompanyMaterial(payload);
                } else {
                  const dialogRef = this.dialog.open(AlertDialogComponent, {
                    disableClose: true,
                    width: '400px',
                    data: {
                      title: 'Success',
                      type: 'Success',
                      message: 'Material updated successfully',
                      buttonText: 'Ok'
                    }
                  });
                  this.dialogRef.close(payload);
                }
              } else {
                if (this.addMaterialForm.get('link').value === this.material.path) {
                  this.dialogRef.close(payload);
                  const dialogRef = this.dialog.open(AlertDialogComponent, {
                    disableClose: true,
                    width: '400px',
                    data: {
                      title: 'Success',
                      type: 'Success',
                      message: 'Material updated successfully',
                      buttonText: 'Ok'
                    }
                  });
                } else {
                  this.updateCompanyMaterial(payload);
                  this.dialogRef.close(payload);
                }
              }
          } else {
            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Error',
                type: 'Error',
                message: 'Something went wrong, Please try again!',
                buttonText: 'Ok'
              }
            });
          }
        });
        this.utils.closeProgressDialog();
      } else if (this.type === 'Add') {
        const payload = {
          description: this.addMaterialForm.get('description').value,
          name: this.addMaterialForm.get('name').value,
        };
        this.utils.showProgressDialog();
        this.dataService.post('companySupportMaterial/CreateCompanySupportMaterial', payload, true).then((data) => {
          if (data.statusCode === 200) {
            this.dialogRef.close(data.data);
            const imagePayload = new FormData();
            imagePayload.append('file', this.filesList && this.filesList.length > 0 && this.fileIconOn ? this.filesList[0] : null);
            imagePayload.append('link', this.filesList && this.filesList.length > 0 && this.fileIconOn  ? null : this.addMaterialForm.get('link').value);
            imagePayload.append('recordId', data.data.id);
            imagePayload.append('type', this.filesList && this.filesList.length > 0 && this.fileIconOn ? '4' : '2');

            this.dataService.put('companySupportMaterial/UpdateCompanySupportMaterialFile', imagePayload, true).then((mediaData) => {
              if (mediaData.statusCode === 200) {
                this.dialogRef.close(payload);
                const dialogRef = this.dialog.open(AlertDialogComponent, {
                  disableClose: true,
                  width: '400px',
                  data: {
                    title: 'Success',
                    type: 'Success',
                    message: 'Material added successfully',
                    buttonText: 'Ok'
                  }
                });
              } else {
                const dialogRef = this.dialog.open(AlertDialogComponent, {
                  disableClose: true,
                  width: '400px',
                  data: {
                    title: 'Error',
                    type: 'Error',
                    message: 'Something went wrong, Please try again!',
                    buttonText: 'Ok'
                  }
                });
              }
            });
          } else {
            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Error',
                type: 'Error',
                message: 'Something went wrong, Please try again!',
                buttonText: 'Ok'
              }
            });
          }
        });
        this.utils.closeProgressDialog();
      }
    } else {
      this.addMaterialForm.markAllAsTouched();
    }
  }

}
